import { ChevronDown, FileText } from 'lucide-react'
import React from 'react'

function CaseDetailsToggleTile({ toggleInfo, setToggleInfo, title, description, icon, variant = "default" }) {
  const accent = variant === "accent";
  return (
     <div
      onClick={() => setToggleInfo(!toggleInfo)}
      className="group flex cursor-pointer my-2 items-center justify-between rounded-[10px] bg-ivory p-4 border border-[rgba(20,33,61,.12)] hover:border-tan transition-colors font-plexsans"
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <div className={"flex items-center justify-center flex-none " + (accent ? "text-tan" : "text-navy")}>
            {
              icon ? icon : <FileText size={18} />
            }
        </div>
        <div className="flex items-baseline gap-2 min-w-0">
          <h3 className={"font-semibold text-[14px] truncate " + (accent ? "text-tan" : "text-navy")}>
           {title}
          </h3>

          {description && (
            <p className="text-[12px] text-[rgba(20,33,61,.45)] truncate">
              {description}
            </p>
          )}
        </div>
      </div>

      <ChevronDown
        size={18}
        className={`transition-transform duration-300 text-tan flex-none ${
          toggleInfo ? "rotate-180" : ""
        }`}
      />
    </div>
  )
}

export default CaseDetailsToggleTile
